import React from 'react';
import ChartCard from './ChartCard';

// import { AccessTime, ArrowUpward, ArrowDropUp } from '@material-ui/icons';
import ChartistGraph from 'react-chartist';
// var Chartist = require('chartist');
// const legend = require('chartist-plugin-legend');

import { Pie } from 'react-chartjs-2';

const PieGraph = ({ ...props }) => {
  const { title, icon, textData, seriesData, labels, statText } = props;

  const pieGraphConfig = {
    data: {
      series: seriesData[0],
    },

    labels: labels,
    datasets: [
      {
        data: seriesData[0],
        backgroundColor: ['#bac2ff', '#4e91fd', '#2c2cff', '#00059f'],
        hoverBackgroundColor: ['#bac2ff', '#4e91fd', '#2c2cff', '#00059f'],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    onClick: (evt, item) => {
      if (item[0]._view.label === 'pending') {
        window.location = `/#/orders/?shippingTime=coming,late,today`;
      } else if (item[0]._view.label === 'sent' || item[0]._view.label === 'Sent') {
        window.location = `/#/orders/?shippingTime=sent`;
      }
    },
    // onClick: (e) => window.location = `/#/orders/?shippingTime=late,today,new`,
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const total = dataset.data.reduce(function(
            previousValue,
            currentValue,
            currentIndex,
            array
          ) {
            return previousValue + currentValue;
          });
          const currentValue = dataset.data[tooltipItem.index];
          const precentage = Math.floor((currentValue / total) * 100);
          return precentage + '%';
        },
      },
    },
  };

  return (
    <ChartCard
      chart={<Pie data={pieGraphConfig} options={options} width={400} height={250} />}
      chartColor="white"
      title={title}
      text={textData}
      statIcon={icon}
      statText={statText}
    />
  );
};

export default PieGraph;



// WEBPACK FOOTER //
// ./src/components/PieGraph.jsx